function getNavigationDimensions(navigation) {
    const dimensions = navigation.getBoundingClientRect();

    return {
        top: dimensions.y,
        bottom: dimensions.bottom,
        height: dimensions.height
    }
}

function openNavigation(navigation, navigationItemsWrapper, backdrop) {
    document.body.style.overflow = "hidden";

    const dimensions = navigation.getBoundingClientRect();

    navigationItemsWrapper.style.maxHeight = window.innerHeight - dimensions.bottom + "px";
    navigation.classList.add("-active");

    backdrop && (backdrop.style.top = dimensions.bottom + "px");
}

function closeNavigation(navigation) {
    document.body.style.overflow = "";

    navigation.classList.remove("-active");

    navigation.querySelectorAll(".-active").forEach(item => item.classList.remove("-active"));
}

function lockBody() {
    document.body.style.overflow = "hidden";
}

function unlockBody() {
    document.body.style.overflow = "";
}

function getNavigationDimensions(menu) {
    const rect = menu.getBoundingClientRect();

    return {
        top: rect.top,
        bottom: rect.bottom,
        height: rect.height
    };
}

function positionDropdown(dropdown, dimensions) {
    dropdown.style.top = `${dimensions.bottom}px`;
    dropdown.style.height = `${window.innerHeight - dimensions.bottom}px`;
}

function openNavigationMenu(elements) {
    lockBody();

    const dimensions = getNavigationDimensions(elements.menu);

    elements.wrapper.style.maxHeight = `${window.innerHeight - dimensions.bottom}px`;
    elements.menu.classList.add("-active");
    elements.backdrop && (elements.backdrop.style.top = `${dimensions.bottom}px`)

    const imageItems = elements.items.filter(el => el.classList.contains("-image"));

    if (imageItems != null && imageItems.length > 0) {
        imageItems.forEach(item => {
            lazyLoadElementImage(item);
        })
    }

    return dimensions;
}

function closeNavigationMenu(elements) {
    unlockBody();

    elements.menu.classList.remove("-active");

    elements.menu
        .querySelectorAll(".-active")
        .forEach(el => el.classList.remove("-active"));
}

function openDropdown(item, dropdown, dimensions) {
    item.classList.add("-active");
    dropdown.classList.add("-active");

    const dropdownImages = item.querySelectorAll(`.navigation-subitem.-image`);

    if (dropdownImages != null && dropdownImages.length > 0) {
        dropdownImages.forEach(image => {
            lazyLoadElementImage(image);
        })
    }

    positionDropdown(dropdown, dimensions);
}

function closeDropdown(item, dropdown) {
    item.classList.remove("-active");
    dropdown.classList.remove("-active");
}

function initDropdown(dropdown, parentItem, dimensions) {
    const backButton = dropdown.querySelector(".dropdown-back");

    if (backButton) {
        backButton.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();

            closeDropdown(parentItem, dropdown);
        });
    }

    dropdown
        .querySelectorAll(":scope > .navigation-list > .navigation-subitem")
        .forEach(item => {
            const title = item.querySelector(".navigation-subitem-title");
            const subDropdown = item.querySelector(".navigation-dropdown");

            item.addEventListener("click", e => {
                e.stopPropagation();

                if (!subDropdown) {
                    if (title?.classList.contains("fbo")) {
                        Foundation.libs.matyWeglot.handleObfuscatedLinkClick(title);
                    }

                    return;
                }

                if (item.classList.contains("-hasDropdown")) {
                    e.preventDefault();
                }

                openDropdown(item, subDropdown, dimensions);
            });

            if (subDropdown) {
                initDropdown(subDropdown, item, dimensions);
            }

        });
}

function initNavigationItem(item, dimensions) {
    const dropdown = item.querySelector(".navigation-dropdown");

    if (!dropdown)
        return;

    item.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();

        openDropdown(item, dropdown, dimensions);
    });

    initDropdown(dropdown, item, dimensions);
}

function initMobileNavigation(elements) {
    elements.backdrop?.addEventListener("click", () => {
        closeNavigationMenu(elements);
    });

    elements.burger.addEventListener("click", () => {
        if (elements.menu.classList.contains("-active")) {
            closeNavigationMenu(elements);
            return;
        }

        const dimensions = openNavigationMenu(elements);

        elements.items
            .filter(item => item.classList.contains("-hasDropdown"))
            .forEach(item => initNavigationItem(item, dimensions));
    });
}

function initDesktopNavigation(elements) {
    elements.items.forEach(item => {
        const dropdowns = item.querySelectorAll(".navigation-dropdown");

        item.addEventListener("mouseenter", () => {
            lockBody();

            const dimensions = getNavigationDimensions(elements.menu);

            elements.backdrop && (elements.backdrop.style.top = `${dimensions.bottom}px`);

            dropdowns.forEach(dropdown =>
                positionDropdown(dropdown, dimensions)
            );

            initDekstopNavigationSubitems(item);
        });

        item.addEventListener("mouseleave", () => {
            unlockBody();

            unloadDekstopNavigationSubitems(item);
        });

    });
}

function unloadDekstopNavigationSubitems(item) {
    const subitems = item.querySelectorAll(".navigation-subitem[data-level='1']");
    subitems.forEach(subitem => subitem.classList.remove("-hovered"))
}

function initDekstopNavigationSubitems(item) {
    const lazyLoadElementImage = (element) => {
        const imgEncoded = element.querySelector("[data-src]");
        const sourceEncoded = element.querySelector("[data-srcset]");

        if (imgEncoded) {
            imgEncoded.src = imgEncoded.getAttribute("data-src");
            imgEncoded.removeAttribute("data-src");
        }

        if (sourceEncoded) {
            sourceEncoded.srcset = sourceEncoded.getAttribute("data-srcset");
            sourceEncoded.removeAttribute("data-srcset");
        }
    }

    const mainSubdropdown = item.querySelector(".navigation-dropdown.-subdropdown.-main-subdropdown");

    if (mainSubdropdown) {
        const mainSubdropdownImages = mainSubdropdown.querySelectorAll(".navigation-subitem.-image");

        if (mainSubdropdownImages && mainSubdropdownImages.length > 0) {
            mainSubdropdownImages.forEach(imageEl => {
                lazyLoadElementImage(imageEl);
            })
        }
    }

    const subitems = item.querySelectorAll(".navigation-subitem[data-level='1']");

    subitems
        .forEach(subitem => {
            subitem.classList.remove("-hovered");

            if (!subitem.classList.contains("-init")) {
                subitem.addEventListener("mouseenter", () => {
                    item
                        .querySelectorAll(".navigation-subitem")
                        .forEach(si => { si.classList.remove("-hovered") });

                    subitem.classList.toggle("-hovered");

                    const imagesEl = subitem.querySelectorAll(".navigation-subitem-image");

                    if (imagesEl && imagesEl.length > 0) {
                        imagesEl.forEach(imageEl => {
                            lazyLoadElementImage(imageEl);
                        })
                    }
                });

                subitem.classList.add("-init");
            }
        });

    item
        .querySelector(".navigation-dropdown[data-dropdown-level='0'] > .navigation-list")
        .addEventListener("mouseleave", (e) => {
            if (e.relatedTarget.classList.contains("navigation-dropdown") && e.relatedTarget.getAttribute("data-dropdown-level") == "0") {
                unloadDekstopNavigationSubitems(item);
            }
        });
}

function lazyLoadElementImage(element) {
    const imgEncoded = element.querySelector("[data-src]");
    const sourceEncoded = element.querySelector("[data-srcset]");

    if (imgEncoded) {
        imgEncoded.src = imgEncoded.getAttribute("data-src");
        imgEncoded.removeAttribute("data-src");
    }

    if (sourceEncoded) {
        sourceEncoded.srcset = sourceEncoded.getAttribute("data-srcset");
        sourceEncoded.removeAttribute("data-srcset");
    }
}

function initNavigationMenu() {
    const header = document.querySelector(".header-site");
    const menu = header?.querySelector(".navigation-menu");

    if (!menu)
        return;

    const elements = {
        menu,
        burger: menu.querySelector(".navigation-burger"),
        backdrop: menu.querySelector(".navigation-backdrop"),
        wrapper: menu.querySelector(".navigation-items"),
        items: [...menu.querySelectorAll(".navigation-item")]
    };

    if (header.classList.contains("-transparent")) {
        const mainContent = document.getElementById("main-content");
        const dimensions = getNavigationDimensions(header);

        if (mainContent && dimensions) {
            mainContent.style.marginTop = `${dimensions.height * -1}px`;

            const handleScroll = () => {
                if (window.scrollY == 0 && !header.classList.contains("-transparent")) {
                    header.classList.add("-transparent");
                } else if (window.scrollY > 0 && header.classList.contains("-transparent")) {
                    header.classList.remove("-transparent");
                }
            }

            handleScroll();

            document.addEventListener("scroll", handleScroll)
        }
    }

    if (window.matchMedia("(width > 1500px)").matches) {
        initDesktopNavigation(elements);
    }
    else {
        initMobileNavigation(elements);
    }

}


function initAcp() {
    const acpModal = document.getElementById("acp-modal")?.modal;

    if (!acpModal) return;

    acpModal.onOpen(() => fetchAcpModal(acpModal, true));
    acpModal.onOpen(() => initAcpSearchInput(acpModal));
    acpModal.onOpen(() => initAcpSearchButton(acpModal));
    acpModal.onOpen(() => initAcpButton(acpModal));
    acpModal.onOpen(() => initAcpKeywords(acpModal));
    acpModal.onOpen(() => focusAcpModalInput(acpModal));
}

function focusAcpModalInput(modal) {
    const input = document.getElementById("acp-search-input");

    if (input) {
        input.focus();
    }
}

async function initAcpSearchInput(modal) {
    const acpSearchInput = modal.element.querySelector("#acp-search-input");

    if (!acpSearchInput) return;

    let timer;
    let tipingInterval = 500;

    acpSearchInput.addEventListener("keydown", (e) => {
        if (e.keyCode == 13) {
            const acpSearchButton = modal.element.querySelector("#acp-search-button");
            const acpSearchInput = modal.element.querySelector("#acp-search-input");

            if (!acpSearchButton || !acpSearchInput) return;

            acpSearch(acpSearchInput.value);

            return;
        }

        clearTimeout(timer);
        timer = setTimeout(async () => await fetchAcpModal(modal, false), tipingInterval);
    })
}

function initAcpSearchButton(modal) {
    const acpSearchButton = modal.element.querySelector("#acp-search-button");
    const acpSearchInput = modal.element.querySelector("#acp-search-input");

    if (!acpSearchButton || !acpSearchInput) return;

    acpSearchButton.addEventListener("click", () => {
        const research = acpSearchInput.value;

        acpSearch(research);
    });
}

function initAcpButton(modal) {
    const acpButton = modal.element.querySelector("#acp-button");
    const acpSearchInput = modal.element.querySelector("#acp-search-input");

    if (!acpButton || !acpSearchInput) return;

    acpButton.addEventListener("click", () => {
        const research = acpSearchInput.value;

        acpSearch(research);
    });
}

function acpSearch(research) {
    window.location.href = `/Achat/${research}?search=${research}`;
}

async function initAcpKeywords(modal) {
    const acpKeywords = modal.element.querySelectorAll(".acp-top-request");

    if (!acpKeywords || acpKeywords.length == 0) return;

    const searchInput = modal.element.querySelector("#acp-search-input");

    Array.from(acpKeywords).forEach(keyword => {
        keyword.addEventListener("click", () => {
            searchInput.value = keyword.innerText;

            fetchAcpModal(modal, true);
        })
    })
}

async function fetchAcpModal(modal, getFullModal) {
    const contentWrapper = modal.element.querySelector("#acp-modal__wrapper");

    if (!contentWrapper) return;

    const searchInput = modal.element.querySelector("#acp-search-input");
    let search = "";

    if (searchInput && searchInput.value && searchInput.value != "") {
        search = searchInput.value;
    }

    try {
        Foundation.libs.common.showPreloader();

        const params = new URLSearchParams({ research: search, getFullModal }).toString();
        const response = await fetch("/Navigation/GetAcpModalContent?" + params);
        const data = await response.json();

        handleACPFetch(data, getFullModal, modal)
    }
    catch (e) {
        console.error(e);

        handleACPFetch({ html: "<p class=\"-error\">Une erreur s'est produite, veuillez ressayer</p>" }, modal);
    }
    finally {
        Foundation.libs.common.hidePreloader();
    }
}

function handleACPFetch(data, replaceFullContent, modal = null) {
    if (!modal) {
        modal = document.getElementById("acp-modal")?.modal
    }

    if (data.redirect != null && data.redirect != "") {
        window.location.href = data.redirect;
    }
    else if (data.html != null && data.html != "") {
        const contentWrapper = replaceFullContent ? modal.element.querySelector("#acp-modal__wrapper") : modal.element.querySelector("#acp-modal-content");

        if (!contentWrapper) {
            return;
        }

        contentWrapper.innerHTML = data.html;

        initAcpKeywords(modal);
        initAcpButton(modal);

        if (replaceFullContent) {
            initAcpSearchInput(modal);
            initAcpSearchButton(modal);
        }

        modal.reinitContent();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initNavigationMenu();
    initAcp();
});

